<template>
  <section class="header-component">
    <img src="https://golstatsimages.blob.core.windows.net/content/escudo_golstats.png" width="28" alt="Logo" />
    <span class="pc">{{ title }}</span>
    <span class="movil" v-html="titlemovil"></span>
  </section>
</template>

<script>
export default {
  name: 'HeaderComponent',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    titlemovil: {
      type: String,
      default: '',
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.pc {
  @media screen and (max-width: 680px) {
    display: none;
  }
}
.movil {
  display: none;
  @media screen and (max-width: 680px) {
    display: inline-block;
  }
}
.header-component {
  height: 44px;
  font-family: 'Circular-Std-Medium';
  line-height: 40px;
  position: relative;
  color: #cbee6a;
  background-color: #132739;
  overflow: hidden;
  border-radius: 3px 3px 0 0;
  border-bottom: 2px solid #cbfb48;
  img {
    width: 28px;
    margin-left: 11px;
    margin-top: 4px;
    float: left;
    @media screen and (max-width: 680px) {
      display: none;
    }
  }
  span {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.1;
    transform: translate(-50%, -50%);
    @media screen and (max-width: 680px) {
      line-height: 15px;
      font-size: 17px;
    }
  }
}
</style>
